<template>
  <div>
    Manager notification is {{state}}
  </div>
</template>

<style scoped>
small {
  display: block;
}
p {
  margin: 0.5em 0 0 0;
}
</style>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters(['approvalSettings']),
    state() {
      return this.approvalSettings.requireNotifyEmail ? 'ON' : 'OFF';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewEmails.vue